export default __webpack_public_path__ + "static/media/bg.4fc9b2c1.png";